<div class="page project">
	<div class="illustrated-item" id="entrada1">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Y después de la cárcel, ¿qué?</p>
			<p>Toda la labor de la asociación está recogido
				en un proyecto llamado: “Y después de la cárcel, ¿qué?”, basado en
				la intervención social que desarrollamos, y que persigue la
				reinserción social de las personas que estuvieron o están en
				situación de privación de libertad.</p>
			<p>Dada la extensión del proyecto, y hasta la
				disponibilidad de una completa edición para web, se pone a
				disposición la descarga de un documento PDF.</p>
		</div>
	</div>
	<div class="illustrated-item" id="entrada2">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Descarga PDF</p>
			<p>Presione el enlace para la descarga:</p>
			<p>
                
                <a class="inline" target="_blank" href="/assets/documents/project.pdf">Proyecto de APROMAR (PDF)</a>
			</p>
		</div>
	</div>
</div>
